if (!window.isMobile) {
  window.isMobile = false;
}
const checkPlatform = () => {
  if (window.innerWidth < 768) {
    window.isMobile = true;
  } else {
    window.isMobile = false;
  }
};
checkPlatform();
window.onresize = checkPlatform;

export default function() {
  if (window.isMobile != undefined) {
    return window.isMobile;
  } else {
    return 'window.isMobile 未定义';
  }
}



// WEBPACK FOOTER //
// ./src/components/is-mobile.js